<template>
  <div v-if="canPin || canHide" class="forum-next-thread-actions" @keydown.esc.stop.prevent="close(true)">
    <details ref="disclosure" @focusout="leave">
      <summary ref="trigger" title="Acciones del hilo" aria-label="Acciones del hilo"><i class="pi pi-ellipsis-h" aria-hidden="true"></i></summary>
      <div class="forum-next-thread-actions__panel">
        <p class="forum-next-meta">Gestionar conversación</p>
        <button v-if="canPin" type="button" :disabled="disabled" @click="choose('pin', !thread.pinned)"><i class="pi pi-thumbtack" aria-hidden="true"></i>{{ thread.pinned ? 'Desfijar hilo' : 'Fijar hilo' }}</button>
        <button v-if="canHide" type="button" :disabled="disabled" @click="choose('hide', !thread.hiddenFromRecent)"><i :class="thread.hiddenFromRecent ? 'pi pi-eye' : 'pi pi-eye-slash'" aria-hidden="true"></i>{{ thread.hiddenFromRecent ? 'Mostrar en Recientes' : 'Ocultar de Recientes' }}</button>
        <p v-if="canHide" class="forum-next-meta">Ocultar no borra el hilo: sigue accesible en su sección y por enlace.</p>
      </div>
    </details>
  </div>
</template>
<script>
export default {
  name: 'ForumThreadActions',
  props: { thread: { type: Object, required: true }, state: { type: Object, default: () => ({}) } },
  computed: {
    canPin() { return this.thread.capabilities.canPin && typeof this.thread.pinned === 'boolean'; },
    canHide() { return this.thread.capabilities.canHide && typeof this.thread.hiddenFromRecent === 'boolean'; },
    disabled() { return Boolean(this.state.pending || this.state.error); }
  },
  mounted() { this.outside = event => { if (!this.$el.contains(event.target)) this.close(); }; document.addEventListener('pointerdown', this.outside); },
  beforeDestroy() { document.removeEventListener('pointerdown', this.outside); },
  methods: {
    close(focus = false) { if (this.$refs.disclosure) this.$refs.disclosure.open = false; if (focus && this.$refs.trigger) this.$refs.trigger.focus(); },
    leave(event) { if (event.relatedTarget && !this.$el.contains(event.relatedTarget)) this.close(); },
    choose(action, value) { if (this.disabled) return; this.close(true); this.$emit('change', action, value); }
  }
};
</script>
